import {formatDate, formatNumber} from '@angular/common'
import {Component, inject, OnInit} from '@angular/core' // Changed
import {MatButton} from '@angular/material/button'
import {MatCard, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle} from '@angular/material/card'
import {MatDialog} from '@angular/material/dialog'
import {MatPaginator} from '@angular/material/paginator'
import {MatSort, MatSortHeader} from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatNoDataRow,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table'
import {RouterLink} from '@angular/router'
import {BlancoLoanApplication, IBlancoResultCode} from '@sparbanken-syd/blanco-backend'
import {AdminService} from '../../services/admin.service'
import {DelegateComponent} from '../delegate/delegate.component'
import {IndicatorComponent} from '../indicator/indicator.component'
import {BaseTable} from '@sparbanken-syd/sparbanken-syd-theme'

interface LoanListItem {
  id?: string
  date: string
  time: string
  applicant: string
  applicantId: string
  coApplicant: string
  coApplicantId?: string
  codes: IBlancoResultCode[]
  amount: string
  delegate?: string
  application: BlancoLoanApplication
  gdprRemove?: number
}

@Component({
  selector: 'spb-blanco-list',
  templateUrl: './blanco-list.component.html',
  styleUrls: ['./blanco-list.component.scss'],
  imports: [
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    RouterLink,
    IndicatorComponent,
    MatButton,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatNoDataRow,
    MatPaginator,
    MatCard,
    MatCardTitle,
    MatCardHeader,
    MatCardSubtitle,
    MatCardContent
  ]
})

export class BlancoListComponent extends BaseTable<LoanListItem> implements OnInit {

  public readonly adminService = inject(AdminService)
  private readonly dialog = inject(MatDialog)

  public ngOnInit(): void {
    this.columns.set(['date', 'time', 'applicant', 'coApplicant', 'granted', 'amount', 'delegate'])

    this.adminService.applications$.subscribe((applications: BlancoLoanApplication[]) => {
      if (applications.length === 1 && applications[0].blancoStatus === -1) {
        return
      }
      this.items.data = applications
        .filter(a => a.blancoState === 'active')
        .map((application: BlancoLoanApplication) => {
          application.timeStamp = application.timeStamp || 0
          application.applicants = application.applicants || []
          application.applicants[0] = application.applicants[0] || {} as any
          application.codes = application.codes || []
          application.loan = application.loan || {amount: 0} as any
          application.adminData = application.adminData || {} as any
          return application
        })
        .map((application: BlancoLoanApplication): LoanListItem => ({
          applicantId: application.applicantId, // Used for filter/search
          coApplicantId: application.coApplicantId, // Used for filter/search
          id: application.itemId,
          date: formatDate(application.timeStamp, 'yyyy-MM-dd', 'sv'),
          time: formatDate(application.timeStamp, 'HH:mm', 'sv'),
          applicant: application.applicants[0].name,
          coApplicant: application.coApplicant ? application.applicants[1].name : '',
          codes: application.codes,
          amount: formatNumber(application.loan.amount, 'sv', '1.0-0'),
          delegate: application.adminData.assignee,
          gdprRemove: application.gdprRemove * 1000,
          application
        }))
    })
  }

  public gdprDate(gdprDate: number | null) {
    return gdprDate ? new Date(gdprDate).toISOString().split('T')[0] : '-'
  }

  public delegate(application: BlancoLoanApplication) {
    this.dialog.open(DelegateComponent, {
      data: {
        application
      },
      disableClose: true
    })
  }
}